import React, { useState } from 'react';
import { Carousel, Button } from 'antd';
import { useNavigate } from 'react-router-dom';
import styles from './ProductItem.module.scss';
import { useTranslation } from 'react-i18next';
// title: 'Hand-woven bamboo basket',
// priceNow:'5.99',
// costPrice:'9.99',
// desc:'100+ items sold',

interface ProductItemProps {
  item: any
  // children: React.ReactNode;
  // getMessage?: (str: string) => void; // 可选的回调函数
}



const ProductItem: React.FC<ProductItemProps> = ({ item }) => {

  const navigate = useNavigate();
  const { t } = useTranslation();
  return (
    <div className={styles['product-item']} onClick={() => navigate(`/ProductDetail/${item.product_id}`)}>
      <div>
        <img className={styles['product-item-top-img']} src={item.product_media_list[0]?.product_media_file_url} alt={item.product_title} />
      </div>
      <div className={styles['product-item-bottom']}>
        <div className={styles['product-item-bottom-title']} title={item.product_title}>{item.product_title}</div>
        <div className={styles['product-item-bottom-price-cost-desc']}>
          <div className={styles['product-item-bottom-price-cost']}>
            <div className={styles['product-item-bottom-price']}>
              ${item.product_sku_values?.find((sku: any) => sku.product_price !== "0.00")?.product_price || item.product_sku_values[0]?.product_price || 0}
            </div>
          </div>
          <div className={styles['product-item-bottom-price-cost-desc']}>
            <div className="text-[#2AAD61] text-[16px] leading-[22px] font-bold hover:text-[#669530] cursor-pointer">{t('common.seeMore')}</div>
          </div>
        </div>


      </div>
    </div>
  );
};

export default ProductItem; 